import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles, Box, Typography, Divider } from '@material-ui/core';
import { withNamespaces, Trans } from 'react-i18next';
import moment from 'moment';
import 'moment/min/locales';

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 1128,
		right: 0,
		left: 0,
		marginLeft: 'auto',
		marginRight: 'auto',
		backgroundColor: '#FAFAF5',
		width: '100%',
		paddingTop: '80px',
		paddingBottom: '80px',
		paddingLeft: '24px',
		paddingRight: '24px',
	},
	// content: {
	// 	maxWidth: 1128,
	// 	right: 0,
	// 	left: 0,
	// 	marginLeft: "auto",
	// 	marginRight: "auto",
	// 	marginTop: theme.spacing(4),
	// },
	titledate: {
		color: '#E0B080',
		fontFamily: 'Ubuntu',
		fontWeight: 'medium',
		fontSize: '16px',
		fontHeight: '24px',
		marginBottom: theme.spacing(3)
	},
	title: {
		color: '#E0B080',
		fontFamily: 'Bebas Neue',
		fontWeight: 'bold',
		fontSize: '30px',
		fontHeight: '30px',
		letterSpacing: '0.3px',
		marginTop: theme.spacing(4)
	},
	subtitle: {
		color: '#070C35',
		fontFamily: 'Ubuntu',
		fontWeight: 'bold',
		fontSize: '18px',
		fontHeight: '30px',
		letterSpacing: '0px',
		marginTop: theme.spacing(5)
	},
	description: {
		color: '#070C35',
		fontFamily: 'Ubuntu',
		fontWeight: 'bold',
		fontSize: '14px',
		fontHeight: '30px',
		letterSpacing: '0px',
		marginTop: theme.spacing(5),
		marginBottom: theme.spacing(10)
	}
}));

export default withNamespaces('static')((props) => {
	const { t } = props;
	const classes = useStyles();
	const language = useSelector((state) => state.language.language);

	const lastEdited = moment('2020-08-19T09:03:20.050Z').locale(language);

	return (
		<Box className={classes.root}>
			<Typography className={classes.titledate}>
				{lastEdited.format('MMMM DD, YYYY')}
			</Typography>
			<Divider fullWidth />
			<Typography className={classes.title}>
				{t('socialoffice.title1')}
			</Typography>
			<Typography className={classes.subtitle}>
				{t('socialoffice.subtitle1')}
			</Typography>
			<Typography className={classes.description}>
				<Trans i18nKey='socialoffice.description1'>
					<br />
					<br />
				</Trans>
			</Typography>
			<Typography className={classes.title}>
				{t('socialoffice.title2')}
			</Typography>
			<Typography className={classes.subtitle}>
				{t('socialoffice.subtitle2')}
			</Typography>
			<Typography className={classes.description}>
				<Trans i18nKey='socialoffice.description2'>
					<br />
					<br />
				</Trans>
			</Typography>
			<Typography className={classes.title}>
				{t('socialoffice.title3')}
			</Typography>
			<Typography className={classes.subtitle}>
				{t('socialoffice.subtitle3')}
			</Typography>
			<Typography className={classes.description}>
				<Trans i18nKey='socialoffice.description3'>
					<br />
					<br />
				</Trans>
			</Typography>
			<Typography className={classes.title}>
				{t('socialoffice.title4')}
			</Typography>
			<Typography className={classes.subtitle}>
				{t('socialoffice.subtitle4')}
			</Typography>
			<Typography className={classes.description}>
				<Trans i18nKey='socialoffice.description4'>
					<br />
					<br />
				</Trans>
			</Typography>
			<Typography className={classes.title}>
				{t('socialoffice.title5')}
			</Typography>
			<Typography className={classes.subtitle}>
				{t('socialoffice.subtitle5.1')}
			</Typography>
			<Typography className={classes.description}>
				<Trans i18nKey='socialoffice.description5.1'>
					<br />
					<br />
				</Trans>
			</Typography>
			<Typography className={classes.subtitle}>
				{t('socialoffice.subtitle5.2')}
			</Typography>
			<Typography className={classes.description}>
				<Trans i18nKey='socialoffice.description5.2'>
					<br />
					<br />
				</Trans>
			</Typography>
			<Typography className={classes.title}>
				{t('socialoffice.title6')}
			</Typography>
			<Typography className={classes.description}>
				{t('socialoffice.description6')}
			</Typography>
		</Box>
	);
});
